import { Reveal } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Source responsibly",
    body: "We collect spent lead-acid batteries and lead-bearing scrap through an organised, compliant channel — keeping hazardous material out of the informal sector.",
  },
  {
    n: "02",
    title: "Refine with precision",
    body: "Controlled smelting and kettle refining deliver a consistent 99.97%+ purity, with every heat verified by spectrometry before it leaves the plant.",
  },
  {
    n: "03",
    title: "Close the loop",
    body: "Recycling is the model. We return lead to the value chain while capturing emissions and effluent — driving landfill and discharge toward zero.",
  },
];

export const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto-section"
    className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40"
  >
    <Reveal>
      <div className="mb-16 flex items-center gap-4 font-mono-tech text-xs uppercase tracking-[0.25em] text-[var(--mx-ink-2)]">
        <span className="h-px w-10 bg-[var(--mx-copper)]" />
        05 — Approach
      </div>
    </Reveal>

    <div className="grid gap-5 md:grid-cols-3">
      {chapters.map((c, i) => (
        <Reveal key={c.n} delay={i * 0.12}>
          <div className="group flex h-full flex-col rounded-2xl border border-[var(--mx-line)] bg-[var(--mx-surface)] p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_24px_60px_-40px_rgba(27,23,20,0.4)] md:p-10">
            <span className="font-mono-tech text-sm text-[var(--mx-copper)]">
              {c.n}
            </span>
            <h3 className="mt-8 font-display text-3xl font-extrabold uppercase leading-none tracking-tight text-[var(--mx-ink)] md:text-4xl">
              {c.title}
            </h3>
            <p className="mt-5 text-base leading-relaxed text-[var(--mx-ink-2)]">
              {c.body}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Manifesto;
